export default {
    data: () => ({
        closingDateError: false,
        closingDateErrorMessage: 'Please select a closing date in the future.'
    }),
    methods: {
        validateClosingDate() {
            let closingDate = null;

            if (!!this?.payAtCloseInputs?.closingDate) {
                closingDate = this.payAtCloseInputs.closingDate;
            } else if (!!this.closingDate) {
                closingDate = this.closingDate;
            } else if (!!this?.formData?.closingDate) {
                closingDate = this.formData.closingDate;
            }

            let closingDateObj = new Date(closingDate).setHours(0, 0, 0, 0);
            let now = new Date();
            let today = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate())).setHours(0, 0, 0, 0);

            if (!!closingDate && closingDateObj.valueOf() < today.valueOf()) {
                this.closingDateError = true;
                return false;
            }

            this.closingDateError = false;
            return true;
        }
    }
};
